<template>
  <div>
    <div style="margin: 10px 40px;">
      <el-button
          @click="getList"
          size='small'
          type="primary"
         
          icon='el-icon-circle-plus'
        >刷新
        </el-button>
    </div>
    <el-row style="margin-top: 10px">

      <el-col :span="4" style="padding:20px;">
<!-- 
      <input type="file" ref="filElem" class="upImage" accept="image/*"   @change="onFileChange" />

       <div v-if="!pic" @click="uppic">上传照片</div>
     <myupload></myupload> -->
     <span>喜报</span>
        <el-image
          :src="imageModel.pcimOrder"
          fit="fill"
          :preview-src-list="imagePreview"
        >
        </el-image>
      </el-col>
      <el-col :span="4" style="padding:20px;">
        <span>日报</span>
        <el-image
          :src="imageModel.pcimDaily"
          fit="fill"
          :preview-src-list="imagePreview"
        >
        </el-image>
      </el-col>
      <el-col :span="4" style="padding:20px;">
        <span>周报</span>
        <el-image
          :src="imageModel.pcimWeekly"
          fit="fill"
          :preview-src-list="imagePreview"
        >
        </el-image>
      </el-col>
      <el-col :span="4" style="padding:20px;">
        <span>月报</span>
        <el-image
          :src="imageModel.pcimMonthly"
          fit="fill"
          :preview-src-list="imagePreview"
        >
        </el-image>
      </el-col>
      <el-col :span="4" style="padding:20px;">
        <span>打卡分享</span>
        <el-image
          :src="imageModel.pcimVisitorShare"
          fit="fill"
          :preview-src-list="imagePreview"
        >
        </el-image>
      </el-col>
      <el-col :span="4" style="padding:20px;">
        <span>订单分享</span>
        <el-image
          :src="imageModel.pcimOrderShare"
          fit="fill"
          :preview-src-list="imagePreview"
        >
        </el-image>
      </el-col>
      <el-col :span="4" style="padding:20px;">
        <span>商机分享</span>
        <el-image
          :src="imageModel.pcimOuShare"
          fit="fill"
          :preview-src-list="imagePreview"
        >
        </el-image>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imageModel: {},
      imagePreview: [],
      pic:'',

    };
  },

  watch: {},

  methods: {
      uppic(){

                    this.$refs.filElem.dispatchEvent(new MouseEvent('click'))

              },

    async  onFileChange(e) {



                let file = e.target.files[0];

                //对文件检查

                let allType = "image/png,image/gif,image/jpeg,image/jpg,image/svg";

                if (allType.indexOf(file.type) == "-1") {

                  showTips("请选择图片文件");

                  return false;

                }
                const form = new FormData(); form.append( 'file', file );
                let res = await this.$post('/opportunity/auth-file/uploadLinux', form, false);
                console.log(res)
              },


              getList(){
                this.getProjectCircleImageModelOne().trigger((res) => {
      this.imageModel = res.data.data;
      this.imagePreview = [
        this.imageModel.pcimOrder,
        this.imageModel.pcimDaily,
        this.imageModel.pcimWeekly,
        this.imageModel.pcimMonthly,
        this.imageModel.pcimVisitorShare,
        this.imageModel.pcimOrderShare,
        this.imageModel.pcimOuShare
      ];
    });
              }

  },

  created() {
    this.getList()
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/model/ProjectCircleImageModel.vue